module.exports = __webpack_public_path__ + "img/Frame-60.a896c1c5.svg";